import { useEffect, useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import Dashboard from './pages/Dashboard';
import StrategySelection from './pages/StrategySelection';
import BotControl from './pages/BotControl';
import ExchangeConnection from './pages/ExchangeConnection';
import BetaDashboard from './pages/BetaDashboard';
import PerformanceDashboard from './pages/PerformanceDashboard';
import NotificationSettings from './pages/NotificationSettings';
import PortfolioSimulator from './pages/PortfolioSimulator';
import ExchangeHub from './pages/ExchangeHub';
import LiveTradingDashboard from './pages/LiveTradingDashboard';
import ReportsPage from './pages/ReportsPage';
import TransitionWizard from './pages/TransitionWizard';
import APIKeyManager from './pages/APIKeyManager';
import AdminPanel from './pages/AdminPanel';
import { Toaster } from './components/ui/sonner';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('apexion_token');
  if (!token) {
    return <Navigate to="/auth" replace />;
  }
  return children;
};

function App() {
  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/exchange"
            element={
              <ProtectedRoute>
                <ExchangeConnection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/strategies"
            element={
              <ProtectedRoute>
                <StrategySelection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/performance"
            element={
              <ProtectedRoute>
                <PerformanceDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/notifications"
            element={
              <ProtectedRoute>
                <NotificationSettings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/simulator"
            element={
              <ProtectedRoute>
                <PortfolioSimulator />
              </ProtectedRoute>
            }
          />
          <Route
            path="/beta"
            element={
              <ProtectedRoute>
                <BetaDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bot/:botId"
            element={
              <ProtectedRoute>
                <BotControl />
              </ProtectedRoute>
            }
          />
          <Route
            path="/exchanges"
            element={
              <ProtectedRoute>
                <ExchangeHub />
              </ProtectedRoute>
            }
          />
          <Route
            path="/live-trading"
            element={
              <ProtectedRoute>
                <LiveTradingDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <ReportsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/transition/:botId"
            element={
              <ProtectedRoute>
                <TransitionWizard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/api-keys"
            element={
              <ProtectedRoute>
                <APIKeyManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminPanel />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;